import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import getConfig from 'next/config';

export const notifyError = (errMsg: string, err: any) => {
  if (
    (Bugsnag !== null || Bugsnag !== undefined) &&
    err?.response?.status !== 401 &&
    err?.response?.status !== 404
  )
    Bugsnag.notify(new Error(errMsg), event => {
      event.severity = 'error';
      event.addMetadata('metaData', err);
    });
};

export const setUpBugsnag = () => {
  if (Bugsnag.isStarted()) {
    return;
  }
  const { publicRuntimeConfig } = getConfig();
  const bugSnagApiKey = publicRuntimeConfig.BUGSNAG_API_KEY;

  Bugsnag.start({
    apiKey: bugSnagApiKey,
    plugins: [new BugsnagPluginReact()],
  });
};
